import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export const getOverviewFn       = httpsCallable(functions, 'getPlatformOverview');
export const getStatsFn          = httpsCallable(functions, 'getPlatformStats');
export const getNotificationsFn  = httpsCallable(functions, 'getPlatformNotifications');
export const sendEmailFn         = httpsCallable(functions, 'sendEmailToCompany');
export const sendBulkEmailFn     = httpsCallable(functions, 'sendBulkEmailToCompanies');
export const setCompanyPlanFn    = httpsCallable(functions, 'setCompanyPlan');
export const setCompanyBlockedFn = httpsCallable(functions, 'setCompanyBlocked');
export const extendDeadlineFn    = httpsCallable(functions, 'extendCompanyDeadline');
export const deleteCompanyNowFn  = httpsCallable(functions, 'deleteCompanyNow');
export const refundBookingFn     = httpsCallable(functions, 'refundBooking');
export const resyncCompanyNowFn  = httpsCallable(functions, 'resyncCompanyNow');
export const setPlatformTestModeFn = httpsCallable(functions, 'setPlatformTestMode');
export const migrateCargosSecretsFn = httpsCallable(functions, 'migrateCargosSecrets');
export const impersonateCompanyFn  = httpsCallable(functions, 'impersonateCompany');
export const endImpersonationFn    = httpsCallable(functions, 'endImpersonation');
export const createPlatformTestBookingFn = httpsCallable(functions, 'createPlatformTestBooking');

// ─── Codici sconto ──────────────────────────────────────────────────────────
export const listPromoCodesFn      = httpsCallable(functions, 'listPromoCodes');
export const createPromoCodesFn    = httpsCallable(functions, 'createPromoCodes');
export const updatePromoCodeFn     = httpsCallable(functions, 'updatePromoCode');
export const deletePromoCodeFn     = httpsCallable(functions, 'deletePromoCode');
